import { useMemo } from 'react'

type PollColors = {
  answerBgColor: string
  answerTextColor: string
  answerBgHoverColor: string
  nextQuestionButtonBgColor: string
  nextQuestionButtonTextColor: string
  nextQuestionButtonBgHoverColor: string
  dropdownButtonBgColor: string
  dropdownButtonTextColor: string
  dropdownButtonBgHoverColor: string
}

type PollQuestionColors = {
  userSelectionResultBarColor: string
  otherSelectionsResultBarColor: string
}

type PollAnswerColors = {
  answerBgColor: string
  answerTextColor: string
  answerBgHoverColor: string
  dropdownButtonBgColor: string
  dropdownButtonTextColor: string
  dropdownButtonBgHoverColor: string
}

export const usePollColors = (poll: any, isSponsored?: boolean) => {
  const pollColors = useMemo(() => {
    const colors: PollColors = {
      answerBgColor: poll.answerBgColor || 'var(--theme-color-primary)',
      answerTextColor: poll.answerTextColor || '#FFF',
      answerBgHoverColor:
        poll.answerBgHoverColor || 'var(--theme-color-primary)',
      nextQuestionButtonBgColor: poll.nextQuestionButtonBgColor || '#FFF',
      nextQuestionButtonTextColor: poll.nextQuestionButtonTextColor || '#000',
      nextQuestionButtonBgHoverColor:
        poll.nextQuestionButtonBgHoverColor ||
        'var(--primary-theme-color-dark)',
      dropdownButtonBgColor:
        poll.dropdownButtonBgColor || 'var(--theme-color-primary)',
      dropdownButtonTextColor: poll.dropdownButtonTextColor || '#FFF',
      dropdownButtonBgHoverColor:
        poll.dropdownButtonBgHoverColor || 'var(--theme-color-primary)',
    }

    if (
      isSponsored === false &&
      colors.answerTextColor.toLowerCase() === '#fff'
    ) {
      colors.answerTextColor = '#000'
    }

    return colors
  }, [isSponsored, poll])

  const getQuestionColors = (question: any) => {
    const questionColors: PollQuestionColors = {
      userSelectionResultBarColor: 'var(--theme-color-primary)',
      otherSelectionsResultBarColor: '#6D6D6D',
    }

    if (question.userSelectionResultBarColor) {
      questionColors.userSelectionResultBarColor =
        question.userSelectionResultBarColor
    }

    if (question.otherSelectionsResultBarColor) {
      questionColors.otherSelectionsResultBarColor =
        question.otherSelectionsResultBarColor
    }

    return questionColors
  }

  const getAnswerColors = (answer: any): PollAnswerColors => {
    // Per-answer color if set (puck stores colors per-answer); otherwise fall
    // back to poll-level color (legacy format stores colors on the poll object).
    let answerTextColor =
      answer?.answerTextColor || pollColors.answerTextColor

    if (isSponsored === false && answerTextColor.toLowerCase() === '#fff') {
      answerTextColor = '#000'
    }

    // Dropdown button: use per-answer color if set (puck always sets it),
    // otherwise fall back to poll-level color (legacy default).
    const dropdownButtonBgColor =
      answer?.dropdownButton?.bgColor || pollColors.dropdownButtonBgColor

    return {
      answerBgColor: answer?.answerBgColor || pollColors.answerBgColor,
      answerTextColor,
      answerBgHoverColor:
        answer?.answerBgHoverColor || pollColors.answerBgHoverColor,
      dropdownButtonBgColor,
      dropdownButtonTextColor:
        answer?.dropdownButton?.textColor || pollColors.dropdownButtonTextColor,
      dropdownButtonBgHoverColor:
        answer?.dropdownButton?.bgHoverColor ||
        pollColors.dropdownButtonBgHoverColor,
    }
  }

  return {
    pollColors,
    getQuestionColors,
    getAnswerColors,
    getProductColors: getAnswerColors,
  }
}
